/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
// In order to add a new Cms document type, you must add it to all 4 places below.
import {
  CmsCarousel,
  CmsCustomStrengthItem,
  CmsCustomStrengthMapping,
  CmsDevelopPage,
  CmsDevelopPlan,
  CmsDocument,
  CmsTeamGoal,
  CmsInfoPage,
  CmsLeaderType,
  CmsLinkResource,
  CmsPackage,
  CmsTeamPathway,
  CmsTeamPathwayStep,
  CmsQuote,
  CmsResource,
  CmsResourcePlaylist,
  CmsResourceTheme,
  CmsResourceThemesPage,
  CmsSession,
  CmsSessionWheel,
  CmsSessionWithSlides,
  CmsStrengthItem,
  CmsSubscriptionPolicy,
  CmsTeamImageList,
  CmsTileData,
  CmsVariable,
  CmsWorkshopPage,
  CmsPersonalGoal,
  CmsPersonalPathway,
  CmsPersonalPathwayStep,
  CmsDigitalPackages,
  CmsSmartCallout,
  CmsSmartSearchPrompts,
  CmsSmartJournalPage,
  CmsSmartTextBox,
  CmsReportResource,
  CmsGoalCapturePage,
  CmsTeamLevel,
  CmsTeamMilestone,
  CmsTeamLevelsAndMilestones,
  CmsPersonalLevelsAndMilestones,
} from "./cms-type-definitions";
import { CmsReport } from "./types/cms-report";
import { CmsTeamEffectivenessReview } from "./types/cms-team-effectiveness-review";

// The list of downloaded types is taken from CmsDocumentTypes.
export enum CmsDocumentTypes {
  CmsGoalCapturePage = "cms-team-goal-capture-page",
  CmsDevelopPage = "cms-develop-page",
  CmsDevelopPlan = "cms-develop-plan",
  CmsStrengthItem = "cms-strength-item",
  CmsCarousel = "cms-carousel",
  CmsVariable = "cms-variable",
  CmsInfoPage = "cms-info-page",
  CmsQuote = "cms-quote",
  CmsResourceThemesPage = "cms-resource-themes-page",
  CmsResourcePlaylist = "cms-resource-playlist",
  CmsResourceTheme = "cms-resource-theme",
  CmsResource = "cms-resource",
  CmsLeaderType = "cms-leader-type",
  CmsLinkResource = "cms-link-resource",
  CmsSession = "cms-session",
  CmsSessionWithSlides = "cms-session-with-slides",
  CmsCustomStrengthMapping = "cms-custom-strength-mapping",
  CmsCustomStrengthItem = "cms-custom-strength-item",
  CmsTeamImageList = "cms-team-image-list",
  CmsWorkshopPage = "cms-workshop-page",
  CmsSessionWheel = "cms-session-wheel",
  CmsTeamEffectivenessReview = "cms-team-effectiveness-review",
  CmsReport = "cms-report",
  CmsPackage = "cms-package",
  CmsDigitalPackages = "cms-digital-packages",
  CmsSubscriptionPolicy = "cms-subscription-policy",
  CmsTeamGoal = "cms-goal",
  CmsTeamPathway = "cms-pathway",
  CmsTeamPathwayStep = "cms-pathway-step",
  CmsPersonalGoal = "cms-personal-goal",
  CmsPersonalPathway = "cms-personal-pathway",
  CmsPersonalPathwayStep = "cms-personal-pathway-step",
  CmsSmartCallout = "cms-smart-callout",
  CmsSmartTextBox = "cms-smart-text-box",
  CmsSmartSearchPrompts = "cms-smart-search-prompts",
  CmsSmartJournalPage = "cms-smart-journal-page",
  CmsReportPage = "cms-report-page",
  CmsTeamLevel = "cms-team-level",
  CmsPersonalLevel = "cms-personal-level",
  CmsTeamMilestone = "cms-team-milestone",
  CmsTeamLevelsAndMilestones = "cms-team-levels",
  CmsPersonalMilestone = "cms-personal-milestone",
  CmsPersonalLevelsAndMilestones = "cms-personal-levels",
}

export interface CmsDocumentTypeMap {
  "cms-team-goal-capture-page": CmsGoalCapturePage;
  "cms-develop-page": CmsDevelopPage;
  "cms-develop-plan": CmsDevelopPlan;
  "cms-strength-item": CmsStrengthItem;
  "cms-carousel": CmsCarousel;
  "cms-variable": CmsVariable;
  "cms-info-page": CmsInfoPage;
  "cms-quote": CmsQuote;
  "cms-resource-themes-page": CmsResourceThemesPage;
  "cms-resource-playlist": CmsResourcePlaylist;
  "cms-resource-theme": CmsResourceTheme;
  "cms-resource": CmsResource;
  "cms-leader-type": CmsLeaderType;
  "cms-link-resource": CmsLinkResource;
  "cms-session": CmsSession;
  "cms-session-with-slides": CmsSessionWithSlides;
  "cms-custom-strength-mapping": CmsCustomStrengthMapping;
  "cms-custom-strength-item": CmsCustomStrengthItem;
  "cms-team-image-list": CmsTeamImageList;
  "cms-workshop-page": CmsWorkshopPage;
  "cms-session-wheel": CmsSessionWheel;
  "cms-team-effectiveness-review": CmsTeamEffectivenessReview;
  "cms-report": CmsReport;
  "cms-monthly-team-theme": CmsResourcePlaylist;
  "cms-this-weeks-focus": CmsResourcePlaylist;
  "cms-package": CmsPackage;
  "cms-digital-packages": CmsDigitalPackages;
  "cms-subscription-policy": CmsSubscriptionPolicy;
  "cms-goal": CmsTeamGoal;
  "cms-pathway": CmsTeamPathway;
  "cms-pathway-step": CmsTeamPathwayStep;
  "cms-personal-goal": CmsPersonalGoal;
  "cms-personal-pathway": CmsPersonalPathway;
  "cms-personal-pathway-step": CmsPersonalPathwayStep;
  "cms-smart-callout": CmsSmartCallout;
  "cms-smart-text-box": CmsSmartTextBox;
  "cms-smart-search-prompts": CmsSmartSearchPrompts;
  "cms-smart-journal-page": CmsSmartJournalPage;
  "cms-report-page": CmsReportResource;
  "cms-team-level": CmsTeamLevel;
  "cms-team-milestone": CmsTeamMilestone;
  "cms-team-levels": CmsTeamLevelsAndMilestones;
  "cms-personal-level": CmsTeamLevel;
  "cms-personal-milestone": CmsTeamMilestone;
  "cms-personal-levels": CmsPersonalLevelsAndMilestones;
}

export const tileFetchLinks: (keyof CmsTileData)[] = ["title_image", "tile_title"];

// These links define what additional information is fetched from the cms via a link.
// Groups and session-slides are ignored.
export const fetchLinkLookup: { [x in CmsDocumentTypes]: (keyof CmsDocumentTypeMap[x]["data"])[] } =
  {
    "cms-develop-page": [
      "name",
      "title",
      "subtitle",
      "strength_item_id",
      "day_or_page_type",
      ...tileFetchLinks,
    ],
    "cms-develop-plan": ["name", "title"],
    "cms-strength-item": ["name", "title", "strength_item_id"],
    "cms-carousel": ["name"],
    "cms-variable": ["name"],
    "cms-smart-search-prompts": ["prompts"],
    "cms-info-page": ["name"],
    "cms-quote": ["name"],
    "cms-resource-themes-page": ["title", ...tileFetchLinks],
    "cms-resource-playlist": ["title", "description", "side_nav_icon", ...tileFetchLinks],
    "cms-session-wheel": ["title", "description", "side_nav_icon", ...tileFetchLinks],
    "cms-resource-theme": ["title", "side_nav_icon", ...tileFetchLinks],
    "cms-resource": ["name", "title", "subtitle", "tile_image_animation", ...tileFetchLinks],
    "cms-leader-type": ["name", "title", ...tileFetchLinks],
    "cms-link-resource": ["title", "link", "link_url", ...tileFetchLinks],
    "cms-session": ["title", ...tileFetchLinks],
    "cms-session-with-slides": ["title", "name", ...tileFetchLinks],
    "cms-custom-strength-item": ["title"],
    "cms-custom-strength-mapping": ["title"],
    "cms-team-image-list": [],
    "cms-workshop-page": ["title", "description", "side_nav_icon", ...tileFetchLinks],
    "cms-team-effectiveness-review": ["title", ...tileFetchLinks],
    "cms-report": ["title", ...tileFetchLinks],
    "cms-package": [
      "title",
      "subtitle",
      "free_trial_period",
      "icon",
      "price",
      "price_description",
      "annual_price",
      "annual_price_description",
      "description",
    ],
    "cms-digital-packages": ["title", "packages"],
    "cms-subscription-policy": ["title", "policy"],
    "cms-goal": ["goal_colour", "full_title", "brief_description", "image"],
    "cms-pathway": [
      "title",
      "title_image",
      "short_description",
      "description",
      "benefits",
      "practicalities",
      "pathway_steps",
      "goal_relationship",
    ],
    "cms-pathway-step": ["title", "title_image", "tile_title"],
    "cms-personal-goal": ["goal_colour", "full_title", "brief_description", "image"],
    "cms-personal-pathway": [
      "title",
      "title_image",
      "short_description",
      "description",
      "benefits",
      "practicalities",
      "pathway_steps",
      "goal_relationship",
    ],
    "cms-personal-pathway-step": ["title", "title_image", "tile_title"],
    "cms-smart-callout": ["name", "prompt"],
    "cms-smart-text-box": [],
    "cms-smart-journal-page": ["name"],
    "cms-report-page": ["title"],
    "cms-team-goal-capture-page": ["title"],
    "cms-team-level": [
      "title",
      "level_type",
      "requires_team_action",
      "level_number",
      "description",
      "uplifts_list",
      "practicalities_list",
      "go_button_text",
      "resource_link",
      "action_resource_link",
      "initiate_pathway",
      "pathway_type",
      "pathway_to_initiate",
    ],
    "cms-team-milestone": ["title", "milestone_number"],
    "cms-team-levels": ["title", "team_levels_and_milestones_list"],
    "cms-personal-level": [
      "title",
      "level_type",
      "level_number",
      "description",
      "uplifts_list",
      "practicalities_list",
      "go_button_text",
      "resource_link",
      "action_resource_link",
      "pathway_type",
      "pathway_to_initiate",
    ],
    "cms-personal-milestone": ["title", "milestone_number"],
    "cms-personal-levels": ["title", "personal_levels_and_milestones_list"],
  };

// These links define what additional information is fetched from the cms via a link.
// Groups and session-slides are ignored.
export const embedLookup: {
  [x in CmsDocumentTypes]: (doc: CmsDocumentTypeMap[x]) => CmsDocument[];
} = {
  "cms-develop-page": () => [],
  "cms-develop-plan": () => [],
  "cms-strength-item": () => [],
  "cms-carousel": () => [],
  "cms-variable": () => [],
  "cms-info-page": () => [],
  "cms-quote": () => [],
  "cms-resource-themes-page": (doc) => doc.data.body.map((x) => x.primary.tile_carousel_embed_link),
  "cms-resource-playlist": () => [],
  "cms-session-wheel": (doc) => doc.data.items.map((x) => x.link),
  "cms-resource-theme": () => [],
  "cms-resource": () => [],
  "cms-leader-type": () => [],
  "cms-link-resource": () => [],
  "cms-session": () => [],
  "cms-session-with-slides": () => [],
  "cms-team-image-list": () => [],
  "cms-custom-strength-mapping": (doc) =>
    ([] as CmsCustomStrengthItem[]).concat.apply(
      [],
      doc.data.pages.map((p) => [
        p.item_1_embed_link,
        p.item_2_embed_link,
        p.item_3_embed_link,
        p.item_4_embed_link,
        p.item_5_embed_link,
        p.item_6_embed_link,
        p.item_7_embed_link,
        p.item_8_embed_link,
        p.item_9_embed_link,
        p.item_10_embed_link,
      ]),
    ),
  "cms-custom-strength-item": () => [],
  "cms-workshop-page": (doc) => [doc.data.resources],
  "cms-team-effectiveness-review": () => [],
  "cms-report": () => [],
  "cms-package": () => [],
  "cms-digital-packages": () => [],
  "cms-subscription-policy": () => [],
  "cms-goal": () => [],
  "cms-pathway": () => [],
  "cms-pathway-step": () => [],
  "cms-personal-goal": () => [],
  "cms-personal-pathway": () => [],
  "cms-personal-pathway-step": () => [],
  "cms-smart-search-prompts": () => [],
  "cms-smart-callout": () => [],
  "cms-smart-text-box": () => [],
  "cms-smart-journal-page": () => [],
  "cms-report-page": () => [],
  "cms-team-goal-capture-page": () => [],
  "cms-team-level": () => [],
  "cms-team-milestone": () => [],
  "cms-team-levels": () => [],
  "cms-personal-level": () => [],
  "cms-personal-milestone": () => [],
  "cms-personal-levels": () => [],
};

export const webAppUrlMap: { [x in CmsDocumentTypes]: string | null } = {
  "cms-develop-page": "/resources/develop/",
  "cms-develop-plan": "/resources/developplans/",
  "cms-strength-item": "/resources/strengths",
  "cms-carousel": null,
  "cms-variable": "/test/cmsvariable/",
  "cms-info-page": null,
  "cms-quote": null,
  "cms-resource-themes-page": "/resources/themes/",
  "cms-resource-theme": "/resources/theme/",
  "cms-resource-playlist": "/resources/playlists/",
  "cms-resource": "/resources/read/",
  "cms-leader-type": "/resources/leadertypes/",
  "cms-session": "/session/",
  "cms-session-with-slides": "/resources/session/",
  "cms-link-resource": "/resources/link/",
  "cms-custom-strength-item": null,
  "cms-custom-strength-mapping": "/review/mappingstrengths/",
  "cms-team-image-list": null,
  "cms-workshop-page": "/session/workshop/",
  "cms-session-wheel": "/resources/wheel/",
  "cms-team-effectiveness-review": null,
  "cms-report": "/resources/report/",
  "cms-report-page": "/resources/cmsreport/",
  "cms-package": "/packages",
  "cms-digital-packages": null,
  "cms-subscription-policy": "/subscriptionpolicy",
  "cms-goal": null,
  "cms-pathway": "/pathway/",
  "cms-pathway-step": "/step/",
  "cms-personal-goal": null, // to implement
  "cms-personal-pathway": "/my/pathway/",
  "cms-personal-pathway-step": "/personal-step/",
  "cms-smart-search-prompts": null,
  "cms-smart-callout": "/cmspreview/smartcallout/",
  "cms-smart-journal-page": "/journal/",
  "cms-smart-text-box": "/cmspreview/smarttextbox/",
  "cms-team-goal-capture-page": null,
  "cms-team-level": null,
  "cms-team-milestone": null,
  "cms-team-levels": null,
  "cms-personal-level": null,
  "cms-personal-milestone": null,
  "cms-personal-levels": null,
};
